<template>
    <div class="tag-input">
      <div
        v-for="(tag, index) in modelValue"
        :key="index"
        :class="['tag', { error: !isValid(tag) }]"
      >
        {{ tag }} <span @click="removeTag(index)">×</span>
      </div>
      <input
        v-model="inputValue"
        @keydown="handleKeydown"
        :class="{ 'input-error': inputError }"
        :placeholder="placeholder"
      />
      <div v-if="inputError" class="error-message">{{ inputError }}</div>
    </div>
  </template>
  
  <script>
  export default {
    name: 'CustomTagsInput',
    props: {
      modelValue: {
        type: Array,
        default: () => []
      },
      validator: {
        type: Function,
        default: () => true  // By default, all tags are valid.
      },
      errorMessage: {
        type: String,
        default: 'Invalid tag'
      },
      placeholder: {
        type: String,
        default: 'Add tag (Tab/Enter)'
      }
    },
    data() {
      return {
        inputValue: '',
        inputError: ''
      };
    },
    methods: {
      handleKeydown(e) {
        if (e.key === 'Tab' || e.key === 'Enter') {
          e.preventDefault();
          const tag = this.inputValue.trim();
          if (tag) {
            if (!this.validator(tag)) {
              this.inputError = this.errorMessage;
              return;
            }
            if (!this.modelValue.includes(tag)) {
              this.$emit('update:modelValue', [...this.modelValue, tag]);
            }
            this.inputValue = '';
            this.inputError = '';
          }
        }
        if (e.key === 'Backspace' && !this.inputValue) {
          this.removeTag(this.modelValue.length - 1);
        }
      },
      removeTag(index) {
        const newTags = [...this.modelValue];
        newTags.splice(index, 1);
        this.$emit('update:modelValue', newTags);
      },
      isValid(tag) {
        return this.validator(tag);
      }
    }
  };
  </script>
  
  <style scoped>
  .tag-input {
    display: flex;
    align-items: center;
    flex-wrap: wrap;
    gap: 5px;
    border-radius: 4px;
  }
  
  .tag {
    background-color: #42c88d;
    color: white;
    padding: 3px 6px;
    border-radius: 3px;
    display: inline-flex;
    align-items: center;
  }
  
  .tag.error {
    background-color: #f44336;
  }
  
  .tag span {
    cursor: pointer;
    margin-left: 5px;
  }
  
  input {
    flex: 1;
    min-width: 120px;
  }
  
  .input-error {
    border-bottom: 1px solid #f44336;
  }
  
  .error-message {
    color: #f44336;
    font-size: 0.8rem;
    width: 100%;
    margin-top: 4px;
  }
  </style>
  